import React, { useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getSchool } from '../../actions/schoolsActions'
import { OnBoardingSchool } from '../../components/helps/OnBoardingSchool'



export default function Dashboard() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {school} = useSelector(state=>state.schools)

    useEffect(() => {
        if(client){
            dispatch(getSchool(client?.id))
        }
    },[dispatch, t, client])

    return (
        <Container className='cuerpo'>
            <Card className='mb-5 sombra'>
                <Card.Body className='px-5 py-5'>
                    <Row>
                        <Col>
                            {/* <h1>{t('dashboard.school.welcome')} {school?.contact}</h1> */}
                            <h1>{t('dashboard.school.welcome')} {school?.name}</h1>
                            <p>{t('dashboard.school.subwelcome')}</p>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col className='onboarding'>
                            <h3 className='mb-4'>{t('dashboard.onboardingSchool.titleProcess')}</h3>
                            <div className='mt-2 mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.paragraph1')}}></div>
                            <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.paragraph2')}}></div>
                            <OnBoardingSchool/>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    )
}